/** 在线工具：前端静态配置，新增工具只改这个文件 */
export interface ToolItem {
  id: number
  slug: string
  name: string
  short: string
  /** 已上线可访问：true 走 router-link，false 显示敬请期待 */
  isActive: boolean
  routeName?: string
  pageTitle?: string
  component?: () => Promise<unknown>
}

export const listTools: ToolItem[] = [
  {
    id: 1,
    slug: '2fa',
    name: '在线 2FA',
    short: 'TOTP 双因素认证生成器',
    isActive: true,
    routeName: 'TwoFA',
    pageTitle: '在线 2FA · 残雪工具分享',
    component: () => import('@/views/TwoFAView.vue')
  },
  {
    id: 2,
    slug: 'img-flow',
    name: '图片转换工具',
    short: '图片格式转换与压缩',
    isActive: true,
    routeName: 'ImgFlow',
    pageTitle: 'ImgFlow · 残雪工具分享',
    component: () => import('@/views/ImgFlowView.vue')
  }
]
